import { isValidPhoneNumber } from "libphonenumber-js/max";

// Phone numbers have at most 15 digits including the dial code (ITU E.164), and the
// shortest common national numbers have 7. Used when the dial code can't be checked.
const isWithinPhoneLength = (digits) => /^\d{7,15}$/.test(digits);

// Checks the number against the rules of its dial code, e.g. +91 needs 10 digits and
// +66 needs 8 or 9. A leading 0 is accepted where the country uses one (0412 345 678).
// Dial codes like "1-268" carry an area code that is part of the number itself.
const isValidForDialCode = (value, dialCode = "") => {
  const digits = String(value);
  if (!/^\d+$/.test(digits)) return false;

  const [callingCode, areaCode = ""] = dialCode.split("-");
  if (!callingCode) return isWithinPhoneLength(digits);

  try {
    return isValidPhoneNumber(`${areaCode}${digits}`, {
      defaultCallingCode: callingCode,
    });
  } catch {
    // Dial codes the library doesn't know, e.g. +379
    return isWithinPhoneLength(digits);
  }
};

// Pass as the options of `validator.message()` together with `getPhoneNumberRule()`.
// Without these options the validator skips the unknown "phone" rule.
export const PHONE_NUMBER_VALIDATION = {
  validators: {
    phone: {
      message: "The :attribute is not valid for the selected country code.",
      messageReplace: (message, [dialCode]) =>
        dialCode
          ? message.replace("the selected country code", `+${dialCode}`)
          : message,
      rule: (value, [dialCode]) => isValidForDialCode(value, dialCode),
    },
  },
};

export const getPhoneNumberRule = (dialCode) => `phone:${dialCode ?? ""}`;
